import { Link, useLocation } from 'react-router-dom';
import './Header.scss';
import logoPath from "../../assets/img/Logo.svg"

const Header = () => {
  const location = useLocation();

  // Обработчик для плавной прокрутки к форме обратной связи
  const scrollToFeedback = (e) => {
    e.preventDefault();
    const feedbackSection = document.getElementById('feedback');
    if (feedbackSection) {
      feedbackSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="header-container">
      <header className="header main-header">
        <div className="header__wrapper header__wrapper-1">
          <div className="logo">
            <Link to="/">
              <img src={logoPath} alt="logo" onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
              }} />
            </Link>
          </div>
        </div>
        <div className="header__wrapper header__wrapper-2">
          <div className="links">
            <Link className={`link link-1 ${location.pathname === '/' ? 'active' : ''}`} to="/">О нас</Link>
            <Link className={`link link-2 ${location.pathname === '/career' ? 'active' : ''}`} to="/career">Карьера</Link>
          </div>
        </div>
        <div className="header__wrapper header__wrapper-3">
          <a id="feedback-btn" href="#feedback" onClick={scrollToFeedback}>
            <button className="nav-btn nav-btn_red">Связаться</button>
          </a>
        </div>
      </header>
    </div>
  );
};

export default Header;
